import { useEffect, useState } from "react";
import { getImports } from "../api/traceabilityApi";

export function useImports(filters) {
  const { product, granularity, from_date, to_date, origin_country } = filters;
  const requestKey = JSON.stringify({ product, granularity, from_date, to_date, origin_country });
  const [result, setResult] = useState({ key: null, data: null, error: null });

  useEffect(() => {
    let live = true;
    getImports({ product, granularity, from_date, to_date, origin_country })
      .then((data) => live && setResult({ key: requestKey, data, error: null }))
      .catch((error) => live && setResult({ key: requestKey, data: null, error }));
    return () => {
      live = false;
    };
  }, [product, granularity, from_date, to_date, origin_country, requestKey]);

  const isCurrentResult = result.key === requestKey;
  return {
    data: isCurrentResult ? result.data : null,
    loading: !isCurrentResult,
    error: isCurrentResult ? result.error : null,
  };
}
